import { images } from '../../constants';

const testimonials = [
  {
    id: 1,
    name: 'Tarikwa Tesfa',
    imgurl: images.tarik,
    company: 'Microverse',
    feedback: 'It is indeed my greatest pleasure to write this recommendation letter for Jos Kalenda. He is one of my close friend and partner. We started collaborating and learning together at Microverse starting from the first Module. He loves working in a group and he is a great team player in addition to his kindness and supportive behavior. During the period, we have collaborated on several projects at Microverse and I noticed that Jos Kalenda is very good with people, has the ability to maximize their potential, and he has a great collaboration skill. He was always very committed and focused on delivering on time.I was also always impressed by his encouragements and support he provides to his peers. I\'m very pleased to recommend Jos Kalenda for the position of a Software developer/Full stack web developer. His skills and leadership qualities would make him an ideal candidate to your Software development team. If you need any additional information about Jos, don\'t hesitate to contact me. Tarikwa Tesfa Email: tariktesfa9090@gmail.com',
  },
  {
    id: 2,
    name: 'Rachid Elaid',
    imgurl: images.rachid,
    company: 'Xtudy',
    feedback: 'Jos was my partner in a couple of projects, and I had a good experience working with him. He is a very respectful man, very active, and willing to always improve as a developer. he makes the working environment feels like with his sense of humor.',
  },
  {
    id: 3,
    name: 'Fatima Ezzahra elemenoun',
    imgurl: images.fatima,
    company: 'Neutral',
    feedback: 'Jos is such a nice person to have around. He is a very creative, respectful, and kind person. He is the guy to go to when you need help and is always open to discussing ideas and suggestions. I like his positive attitude and I\'d like to work with him again.',
  },
  {
    id: 4,
    name: 'Tobin Chilongo',
    imgurl: images.tobin,
    company: 'Microverse',
    feedback: 'Jos is exactly the sort of software developer any company would love. I met them while struggling with a tough coding project problem, and within a few minutes, He managed to explain a concept I\'d been struggling with for days. He has a great way of simplifying complex problems into bite-sized pieces, and as a junior developer, that was really valuable for me. He\'s also just a fun person to chat with! If you need to get a job done simply and efficiently, Jos\'s definitely the person for you.',
  },
  {
    id: 5,
    name: 'Steve W Dames Jr',
    imgurl: images.steve,
    company: 'Xoommit',
    feedback: 'Diligently committed! This is the first thing that comes to mind when I think of the work ethic displayed by this individual. Jos Kalenda is a stellar team grower and a delightfully skilled engineer, logical thinker, and website designer. It was a privilege learning from and working with Jos over the past several months. Any company with an eye towards professional and quality work would be happy to have Jos as a team member and invaluable asset.',
  },

];

export const brands = [
  {
    id: 1,
    name: 'Microverse',
    imgUrl: images.microverse,
  },
  {
    id: 2,
    name: 'Neutral',
    imgUrl: images.neutral,
  },
  {
    id: 3,
    name: 'cyw',
    imgUrl: images.cyw,
  },
];

export default testimonials;
